import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import Typed from 'typed.js'

interface Props {
  text: string
  setShowActions: (show: boolean) => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'typed-output',
  props: {
    text: null,
    setShowActions: null
  },
  setup(__props: any) {

const props = __props as {
  text: string
  setShowActions: (show: boolean) => void
}



const typedObject = ref<Typed | null>(null)
const typedElement = ref<HTMLDivElement | null>(null)

function type (text: string): void {
    const typingElement = typedElement.value?.querySelector('.typing') || null
    if (typingElement === null) {
        return
    }

    typedObject.value?.destroy()

    typedObject.value = new Typed(
        typingElement,
        {
            strings: [text],
            showCursor: text === '',
            onComplete: () => { if (props.text.length > 0) { props.setShowActions(true) } }
        }
    )
}

onMounted(() => {
    type(props.text)
})

watch(() => props.text, (newValue: string) => {
    type(newValue)
})

onBeforeUnmount(() => {
    typedObject.value?.destroy()
})

return { __sfc: true,props, typedObject, typedElement, type }
}

})